import React, { useEffect, useState } from 'react'
import ErrorBoundary from '../../../../components/FundDetails/Modules/Performance/ErrorBoundary.jsx'
import * as StringFormatter from '../../../../global/formatters/string-formatter.js'
import DOMPurify from 'dompurify'
import { getRelativeBasePath } from '../../../../global/environments/path.js'
import Loader from '../../../../components/FundDetails/Modules/Shared/Loader.jsx'
import { stickyOnScroll } from '../helpers/InvestmentProductsHelper.js'
import combineMorningstarfundsReducer, {
  productTypes,
} from './combineMorningstarfundsReducer.js'
import Filters from './Filters.jsx'
import {
  renderStars,
  renderColumnHeader,
  renderColumnCell,
  sortFunds,
} from './combineMorningstarFundsHelper.jsx'
import { removeSpecialCharacters } from '../../../utility/index.js'

function CombineMorningstarfunds() {
  const [tableHeaderTop, setTableHeaderTop] = useState(0)
  const state = combineMorningstarfundsReducer()
  const {
    isLoading,
    rowsData,
    selectedSort,
    selectedSortType,
    selectedSortDirection,
    onClickSort,
    selectedDisplayMorningstarGroup,
    selectedGroups,
    onClickToggleGroup,
  } = state

  useEffect(() => {
    stickyOnScroll(setTableHeaderTop)
  }, [])
  const getAspect = () => {
    const _aspects = {
      columnSummaries: [
        {
          name: 'headerSummary1',
          className: 'bordered',
          colSpan: 0,
          content: () => null,
        },
        {
          name: 'headerSummary2',
          className: 'bordered',
          colSpan: 0,
          content: () => null,
        },
        {
          name: 'headerSummary3',
          className: 'bordered',
          colSpan: 0,
          content: () => null,
        },
        {
          name: 'headerSummary4',
          className: 'bordered',
          colSpan: 4,
          content: () => {
            return (
              <>
                Morningstar Rating as of{' '}
                {(rowsData.length > 0 &&
                  StringFormatter.formatDateStandard(rowsData[0].asOfDate)) ||
                  ''}
              </>
            )
          },
        },
        {
          name: 'headerSummary5',
          colSpan: 1,
          content: () => null,
          hide: selectedDisplayMorningstarGroup,
        },
      ],
      columns: [
        {
          name: 'symbol',
          className:
            'Table-header sorting bordered' +
            (selectedSort === 'symbol'
              ? selectedSortDirection
                ? ' is-ascending'
                : ' is-descending'
              : ''),
          ariaLabel: 'Ticker: activate to sort column descending',
          content: <>Ticker</>,
          button: {
            className:
              'Table-headerNode u-padding2gu u-paddingRight4gu' +
              (selectedSort === 'symbol' ? ' Icon--before' : ''),
            sort: 'symbol',
            sortType: 'string',
          },
          cell: {
            className: ' bordered-right',
            content: (fund) => <div>{fund.symbol}</div>,
          },
        },
        {
          name: 'fundName',
          className:
            'Table-header sorting bordered' +
            (selectedSort === 'fundName'
              ? selectedSortDirection
                ? ' is-ascending'
                : ' is-descending'
              : ''),
          ariaLabel: 'Fund Name: activate to sort column descending',
          content: <>Fund Name</>,
          button: {
            className:
              'Table-headerNode u-padding2gu u-paddingRight4gu' +
              (selectedSort === 'fundName' ? ' Icon--before' : ''),
            sort: 'fundName',
            sortType: 'string',
          },
          cell: {
            className: ' bordered-right',
            content: (fund) => (
              <div>
                <span className="u-textSecondary u-block">
                  <a
                    href={DOMPurify.sanitize(
                      getRelativeBasePath() +
                        `/investment-products/${
                          fund?.productType
                        }/${StringFormatter.urlSafe(removeSpecialCharacters(fund.fundName))}/Class-${
                          fund?.fundClass
                        }/details/?cusip=${fund.cusip}`
                    )}
                  >
                    {fund.fundName}
                  </a>
                </span>
                {fund.productType !== productTypes.ETF && (
                  <span>Class - {fund.fundClass}</span>
                )}
              </div>
            ),
          },
        },
        {
          name: 'fundType',
          className:
            'Table-header sorting bordered' +
            (selectedSort === 'fundType'
              ? selectedSortDirection
                ? ' is-ascending'
                : ' is-descending'
              : ''),
          ariaLabel: 'Fund Type: activate to sort column descending',
          content: <>Fund Type</>,
          button: {
            className:
              'Table-headerNode u-padding2gu u-paddingRight4gu' +
              (selectedSort === 'fundType' ? ' Icon--before' : ''),
            sort: 'fundType',
            sortType: 'string',
          },
          cell: {
            className: ' bordered-right',
            content: (fund) => <span>{fund.fundType}</span>,
          },
        },
        {
          name: 'msOverallRating',
          className:
            'Table-header sorting' +
            (selectedSort === 'msOverallRating'
              ? selectedSortDirection
                ? ' is-ascending'
                : ' is-descending'
              : ''),
          ariaLabel: 'Morningstar Overall Rating: activate to sort column',
          content: <>Overall</>,
          button: {
            className:
              'Table-headerNode u-padding2gu u-paddingRight4gu' +
              (selectedSort === 'msOverallRating' ? ' Icon--before' : ''),
            sort: 'msOverallRating',
            sortType: 'number',
            sortDirection: false,
          },
          cell: {
            content: (fund) =>
              renderStars(fund.msOverallRating, fund.overallFunds),
          },
        },
        {
          name: 'threeYearRating',
          className:
            'Table-header sorting' +
            (selectedSort === 'threeYearRating'
              ? selectedSortDirection
                ? ' is-ascending'
                : ' is-descending'
              : ''),
          ariaLabel: 'Morningstar 3 Year Rating: activate to sort column',
          content: <>3 Year</>,
          button: {
            className:
              'Table-headerNode u-padding2gu u-paddingRight4gu' +
              (selectedSort === 'threeYearRating' ? ' Icon--before' : ''),
            sort: 'threeYearRating',
            sortType: 'number',
            sortDirection: false,
          },
          cell: {
            content: (fund) =>
              renderStars(fund.threeYearRating, fund.threeYearFunds),
          },
        },
        {
          name: 'fiveYearRating',
          className:
            'Table-header sorting' +
            (selectedSort === 'fiveYearRating'
              ? selectedSortDirection
                ? ' is-ascending'
                : ' is-descending'
              : ''),
          ariaLabel: 'Morningstar 5 Year Rating: activate to sort column',
          content: <>5 Year</>,
          button: {
            className:
              'Table-headerNode u-padding2gu u-paddingRight4gu' +
              (selectedSort === 'fiveYearRating' ? ' Icon--before' : ''),
            sort: 'fiveYearRating',
            sortType: 'number',
            sortDirection: false,
          },
          cell: {
            content: (fund) =>
              renderStars(fund.fiveYearRating, fund.fiveYearFunds),
          },
        },
        {
          name: 'tenYearRating',
          className:
            'Table-header sorting bordered' +
            (selectedSort === 'tenYearRating'
              ? selectedSortDirection
                ? ' is-ascending'
                : ' is-descending'
              : ''),
          ariaLabel: 'Morningstar 10 Year Rating: activate to sort column',
          content: <>10 Year</>,
          button: {
            className:
              'Table-headerNode u-padding2gu u-paddingRight4gu' +
              (selectedSort === 'tenYearRating' ? ' Icon--before' : ''),
            sort: 'tenYearRating',
            sortType: 'number',
            sortDirection: false,
          },
          cell: {
            className: ' bordered-right',
            content: (fund) =>
              renderStars(fund.tenYearRating, fund.tenYearFunds),
          },
        },
        {
          name: 'msCategoryName',
          className:
            'Table-header sorting' +
            (selectedSort === 'msCategoryName'
              ? selectedSortDirection
                ? ' is-ascending'
                : ' is-descending'
              : ''),
          ariaLabel: 'Morningstar Category: activate to sort column',
          content: <>Morningstar Category</>,
          button: {
            className:
              'Table-headerNode u-padding2gu u-paddingRight4gu' +
              (selectedSort === 'msCategoryName' ? ' Icon--before' : ''),
            sort: 'msCategoryName',
            sortType: 'array',
          },
          hide: selectedDisplayMorningstarGroup,
          cell: {
            content: (fund) => fund.msCategoryName,
          },
        },
      ],
    }

    return _aspects
  }
  const aspect = getAspect()

  let currentMorningstarCategory = ''

  return (
    <>
      <Filters {...state} />
      {isLoading ? (
        <Loader showBackground={false} />
      ) : (
        <>
          <div className="Form-label u-flexAuto">
            Displaying{' '}
            <span
              className="u-textBold"
              data-qa-automation="displayingFundCount"
            >
              {rowsData?.length || 0}
            </span>{' '}
            fund(s)
          </div>
          <table className="Table Table--reversed Table--sortable u-sm-block u-overflowX InvestmentProductTable">
            <thead
              className="Table-head is-sticky"
              style={{
                top: tableHeaderTop,
              }}
            >
              <tr role="row" className="Table-row">
                {aspect?.columnSummaries
                  ?.filter((col) => !col.hide)
                  ?.map((th) => (
                    <th
                      key={th.name}
                      colSpan={th.colSpan}
                      className={`Table-header u-bgColorBrandDark u-padding2gu u-alignTop u-textNoWrap ${th?.className}`}
                      role="columnheader"
                    >
                      {th.content()}
                    </th>
                  ))}
              </tr>
              <tr role="row" className="Table-row">
                {aspect.columns
                  .filter((column) => !column.hide)
                  .map((column) =>
                    renderColumnHeader(
                      column,
                      selectedSortDirection,
                      onClickSort
                    )
                  )}
              </tr>
            </thead>
            {rowsData.length < 1 ? (
              <tbody className="Table-body Table-row">
                <tr>
                  <td className="Table-cell" colSpan={12}>
                    No matching funds found.
                  </td>
                </tr>
              </tbody>
            ) : (
              sortFunds(
                rowsData,
                selectedSortDirection,
                selectedSortType,
                selectedSort
              ).map((fund, idx) => {
                const showGroup =
                  fund.msCategoryName !== currentMorningstarCategory
                currentMorningstarCategory =
                  fund.msCategoryName || fund.msCategory

                return (
                  <tbody
                    className="Table-body Table-row"
                    key={`${fund.fundType}-${idx}`}
                  >
                    {selectedDisplayMorningstarGroup && showGroup ? (
                      <tr
                        className="Table-row-group u-borderColorNeutralLight u-borderLeft0 u-borderRight0"
                        data-group={currentMorningstarCategory}
                        onClick={onClickToggleGroup}
                        data-qa-automation="morningstar-category-group"
                      >
                        <td className="Table-cell bordered-right" colSpan={3}>
                          <div className="u-flex">
                            <div
                              className={
                                'u-paddingHoriz1gu u-textSizeMsrp4' +
                                (selectedGroups.indexOf(
                                  currentMorningstarCategory
                                ) < 0
                                  ? ' Table-row-group-iconOpen'
                                  : '')
                              }
                            >
                              {selectedGroups.indexOf(
                                currentMorningstarCategory
                              ) < 0
                                ? '-'
                                : '+'}
                            </div>
                            <div className=" u-flexAlignCenter u-flexAlignContentCenter u-textBold u-paddingLeft2gu">
                              Morningstar Category: {currentMorningstarCategory}
                            </div>
                          </div>
                        </td>
                        <td className="Table-cell">
                          {fund.overallFunds} Funds
                        </td>
                        <td className="Table-cell">
                          {fund.threeYearFunds} Funds
                        </td>
                        <td className="Table-cell">
                          {fund.fiveYearFunds} Funds
                        </td>
                        <td className="Table-cell">
                          {fund.tenYearFunds} Funds
                        </td>
                      </tr>
                    ) : null}
                    {selectedGroups.indexOf(currentMorningstarCategory) < 0 ? (
                      <tr role="row">
                        {aspect.columns
                          .filter((column) => !column.hide)
                          .map((column) =>
                            renderColumnCell(
                              {
                                ...column,
                                key: `${fund.fundType}-${idx}-${column.name}`,
                              },
                              fund
                            )
                          )}
                      </tr>
                    ) : null}
                  </tbody>
                )
              })
            )}
          </table>
        </>
      )}
    </>
  )
}

export default function CombineMorningstarfundsContainer() {
  return (
    <div className="u-sizeConstrained Content investment-products">
      <ErrorBoundary
        title="Morningstar Rated Funds"
        message="Morningstar Rated Fund information is currently unavailable due to a technical issue. Please try again later."
        isConstrained={true}
      >
        <CombineMorningstarfunds />
      </ErrorBoundary>
    </div>
  )
}
